<template>
  <div
    :class="[
      'styled-html',
      'not-last:[&_h2]:mb-4 not-last:[&_ol]:mb-4 not-last:[&_p]:mb-4 not-last:[&_ul]:mb-4',
      'not-first:[&_h2]:mt-8',
      '[&_ol]:pl-[2ch]',
      '[&_ol_li]:list-[inherit]',
      '[&_p]:max-w-readable-text',
      '[&_ul]:flex [&_ul]:list-none [&_ul]:flex-col [&_ul]:gap-4 [&_ul]:pl-ch',
      '[&_ul_li]:pl-ch',
      '[&_ul_li::marker]:text-primary-900',
    ]"
  >
    <slot></slot>
  </div>
</template>

<style scoped>
.styled-html {
  :deep() {
    ul {
      li {
        &::marker {
          content: '\f054';
          font-family: 'Font Awesome 7 Pro';
        }
      }
    }
  }
}
</style>
